import DefaultContext from 'flexbiz-core/components/auth/Context';
import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { AiFillCopy, AiFillDelete, AiFillEdit, AiFillFileAdd, AiFillPrinter } from 'react-icons/ai';
import { BiExport, BiImport } from 'react-icons/bi';
import { TfiReload } from 'react-icons/tfi';
import { useCore } from '../../../../hooks';
import VButton from '../../VComponent/VButton';
import LayoutContainer from '../../components/LayoutContainer';
import TableManager from '../../components/tableManager/TableManager';
import withContainer from '../../withContainer';
import { formatNumberWithSpaces } from '../Utils';
import NotiDialog from '../components/NotiDialog';
import VoucherFilter from '../components/VoucherFilter';
import DetailVoucherHD3 from './DetailVoucherHD3';
import AddVoucherHD3 from './Dialog/AddVoucherHD3';
import CopyVoucherHD3 from './Dialog/CopyVoucherHD3';
import EditVoucherHD3 from './Dialog/EditVoucherHD3';
export const VoucherContext = createContext();

const columns = [
	{
		Header: 'Ngày chứng từ',
		accessor: 'ngay_ct',
		width: 150,
		minWidth: 100,
		maxWidth: 400,
		Filter: false,
	},
	{
		Header: 'Mã CT',
		accessor: 'ma_ct',
		width: 80,
		minWidth: 70,
		maxWidth: 400,
		Filter: false,
	},
	{
		Header: 'Số CT',
		accessor: 'so_ct',
		width: 80,
		minWidth: 70,
		maxWidth: 400,
		Filter: false,
	},
	{
		Header: 'Trạng thái CT',
		accessor: 'trang_thai',
		width: 150,
		minWidth: 100,
		maxWidth: 400,
	},
	{
		Header: 'SL trả',
		accessor: 't_sl',
		width: 80,
		minWidth: 70,
		maxWidth: 400,
		Filter: false,
	},
	{
		Header: 'Tiền CK trả',
		accessor: 't_ck_nt',
		width: 100,
		minWidth: 80,
		maxWidth: 400,
		Filter: false,
	},
	{
		Header: 'VAT trả',
		accessor: 't_thue_vao_nt',
		width: 100,
		minWidth: 80,
		maxWidth: 400,
		Filter: false,
	},
	{
		Header: 'Tổng trả',
		accessor: 't_tt_nt',
		width: 100,
		minWidth: 80,
		maxWidth: 400,
		Filter: false,
	},
	{
		Header: 'SL đổi',
		accessor: 't_sl_doi',
		width: 80,
		minWidth: 70,
		maxWidth: 400,
		Filter: false,
	},
	{
		Header: 'Chênh lệch',
		accessor: 't_chenh_lech_nt',
		width: 120,
		minWidth: 70,
		maxWidth: 400,
		Filter: false,
	},
	{
		Header: 'Loại tiền',
		accessor: 'ma_nt',
		width: 90,
		minWidth: 80,
		maxWidth: 400,
		Filter: false,
	},
	{
		Header: 'Tỷ giá',
		accessor: 'ty_gia',
		width: 80,
		minWidth: 70,
		maxWidth: 400,
		Filter: false,
	},
	// {
	// 	Header: "Đơn vị",
	// 	accessor: "ten_dvcs",
	// 	width: 150,
	// 	minWidth: 100,
	// 	maxWidth: 400,
	// 	Filter: false,
	// },
	{
		Header: 'Tên TK có',
		accessor: 'ten_tk_co',
		width: 150,
		minWidth: 100,
		maxWidth: 400,
		Filter: false,
	},
	{
		Header: 'Mã khách hàng',
		accessor: 'ma_kh',
		width: 150,
		minWidth: 100,
		maxWidth: 400,
		Filter: false,
	},
	{
		Header: 'Tên khách hàng',
		accessor: 'ten_kh',
		width: 150,
		minWidth: 100,
		maxWidth: 400,
	},
	{
		Header: 'Diễn giải',
		accessor: 'dien_giai',
		width: 250,
		minWidth: 200,
		maxWidth: 400,
		disableSortBy: true,
		Filter: false,
	},
];

function VoucherHD3({ title, api }) {
	const core = useCore();
	const [openAdd, setOpenAdd] = useState(false);
	const [openEdit, setOpenEdit] = useState(false);
	const [openCopy, setOpenCopy] = useState(false);
	const [openDelete, setOpenDelete] = useState(false);
	const MenuTabTable = [
		{
			id: 1,
			name: 'Mới',
			icon: <AiFillFileAdd />,
			handle: () => {
				setOpenAdd(true);
			},
		},
		{
			id: 2,
			name: 'Sửa',
			icon: <AiFillEdit />,
			handle: () => {
				setOpenEdit(true);
			},
		},
		{
			id: 3,
			name: 'Xoá',
			icon: <AiFillDelete />,
			handle: () => {
				handleDeleteVoucher();
			},
		},
		{
			id: 4,
			name: 'Chép dữ liệu',
			icon: <AiFillCopy />,
			handle: () => {
				setOpenCopy(true);
			},
		},
		// {
		// 	id: 5,
		// 	name: "Tìm",
		// 	icon: <RiFileSearchFill />,
		// },
		// {
		// 	id: 6,
		// 	name: "Xem",
		// 	icon: <AiOutlineFundView />,
		// 	handle: () => {
		// 		setOpenEdit(true);
		// 	},
		// },
		{
			id: 7,
			name: 'In',
			icon: <AiFillPrinter />,
		},
		{
			id: 8,
			name: 'Nhập',
			icon: <BiImport />,
		},
		{
			id: 9,
			name: 'Xuất',
			icon: <BiExport />,
		},
		// {
		// 	id: 10,
		// 	name: "Làm mới",
		// 	icon: <MdRefresh />,
		// },
	];
	const [totalRows, setTotalRows] = useState();
	const [params, setParams] = useState({
		limit: 20,
		page: 1,
		t: 1,
	});
	const [dataVoucherHD3, setDataVoucherHD3] = useState([]);
	const [dataVoucherDetail, setDataVoucherDetail] = useState('');
	const [dataDoubleClick, setDataDoubleClick] = useState('');
	const [dataVoucherSelect, setDataVoucherSelect] = useState('');
	const context = useContext(DefaultContext);

	const skipResetRef = React.useRef(false);
	const updateMyData = (rowIndex, columnId, value) => {
		skipResetRef.current = true;
		setDataVoucherHD3((old) =>
			old.map((row, index) => {
				if (index === rowIndex) {
					return {
						...row,
						[columnId]: value,
					};
				}
				return row;
			})
		);
	};

	const handleCloseAdd = () => {
		getDataVoucherHD3();
		setOpenAdd(false);
	};

	const handleCloseEdit = () => {
		setOpenEdit(false);
		setDataDoubleClick('');
	};

	// xử lý trả ra data khi click vào nút copy
	const handleDataCopyVoucher = (dataNew) => {
		const dataCopy = dataNew.map((item) => {
			return {
				...item,
				so_ct: '',
				_id: undefined,
				ngay_ct: new Date(),
			};
		});
		return dataCopy;
	};

	const handleCloseCopy = () => {
		getDataVoucherHD3();
		setOpenCopy(false);
	};

	const handleCloseDelete = () => {
		setOpenDelete(false);
	};

	const getDataVoucherDetail = (data) => {
		setDataVoucherDetail(data);
	};

	const handleSelectRow = (data) => {
		handleCloseEdit();
		setDataVoucherSelect(data);
	};

	// get data HD31 voucher
	const getDataVoucherHD3 = useCallback(async () => {
		core.setProgressStatus(true);

		try {
			const [data, count] = await Promise.all([
				core.asyncGetList(core.token, api, {
					...params,
				}),
				core.asyncGetList(core.token, api, {
					count: 1,
					q: params.q,
				}),
			]);

			// set total pages
			const totalItem = count.rows_number;
			setDataVoucherHD3(data);
			setTotalRows(totalItem);
			setDataVoucherDetail(data[0] || '');
		} catch (error) {
			console.log('getDataProduct error', error);
		} finally {
			context.setProgressStatus(false);
		}
	}, [context, params]);

	// Xử lý tổng tiền HD31 voucher
	useEffect(() => {
		handleSumTotal(dataVoucherHD3);
	}, [dataVoucherHD3]);

	const handleSumTotal = (data) => {
		let sum = 0;
		data.forEach((item) => {
			sum += item.t_tt;
		});
		return formatNumberWithSpaces(sum);
	};

	// delete data HD31 voucher
	const deleteDataVoucherHD3 = useCallback(
		async (id) => {
			core.contextAlert('Bạn có chắc chắn muốn xóa không?', async (isConfirm) => {
				if (!isConfirm) return;

				core.setProgressStatus(true);

				try {
					await core.asyncDeleteList(core.token, api, id);
					await getDataVoucherHD3();
				} catch (error) {
					core.contextAlert(error);
				} finally {
					core.setProgressStatus(false);
				}
			});
		},
		[context, getDataVoucherHD3]
	);
	const deleteDataVoucherHD3List = useCallback(
		async (ids) => {
			core.contextAlert(`Bạn có chắc chắn muốn xóa ${ids.length} dòng không?`, async (isConfirm) => {
				if (!isConfirm) return;
				core.setProgressStatus(true);
				try {
					const errors = [];
					await Promise.all(
						ids.map((id) => core.asyncDeleteList(core.token, api, id).catch((error) => errors.push(error)))
					);
					if (errors.length) {
						core.contextAlert(
							<>
								<p>{`Có ${errors.length}/${ids.length} dòng không xóa được`}</p>
								{errors.map((e, index) => (
									<div key={index}>{e.error || e}</div>
								))}
							</>
						);
					}
				} catch (error) {
					core.contextAlert(error);
				} finally {
					await getDataVoucherHD3();
					core.setProgressStatus(false);
				}
			});
		},
		[context, getDataVoucherHD3]
	);

	// handle pagination
	const handlePaginationChange = (page, limit) => {
		setParams({
			...params,
			page,
			limit,
		});
	};

	// on select row click
	const onSelectRowClick = (row) => {
		// console.log(row);
		handleSelectRow(row);
	};

	// on row click
	const onRowClick = (row) => {
		getDataVoucherDetail(row);
	};

	// on row double click
	const onRowDoubleClick = (row) => {
		setDataDoubleClick([row]);
	};

	// // hàm xử lý nếu sau khi getDataVoucherHD3 thì table sẽ thay đổi data, tôi muốn set lại state của voucherDetail đúng với row đã click trước đó
	// useEffect(() => {
	// 	if (dataVoucherDetail) {
	// 		const data = dataVoucherHD3.find(
	// 			(item) => item._id === dataVoucherDetail._id
	// 		);
	// 		setDataVoucherDetail(data);
	// 	}
	// }, [dataVoucherDetail, dataVoucherHD3]);

	const handleDeleteVoucher = async () => {
		if (dataVoucherSelect.length === 1) {
			await deleteDataVoucherHD3(dataVoucherSelect[0]._id);
		} else if (dataVoucherSelect.length > 1) {
			await deleteDataVoucherHD3List(dataVoucherSelect.map((item) => item._id));
		} else {
			setOpenDelete(true);
		}
		// setDataVoucherSelect([]);
		// setDataVoucherDetail("");
	};

	const handleFilter = (filter) => {
		const newParams = { ...params };

		// Update params
		newParams.page = 1;
		newParams.q = filter;
		setParams(newParams);
	};

	useEffect(() => {
		getDataVoucherHD3();
	}, [params.page, params.limit, getDataVoucherHD3]);

	return (
		<React.Fragment>
			<VoucherContext.Provider
				value={{
					getDataVoucherHD3,
				}}
			>
				<LayoutContainer>
					<div className="box_new_voucher column-start">
						<div className="box_voucher column-start">
							<div className="column-start box_voucher__header">
								<div className="flex-start box_voucher__header__title">
									<div>
										<TfiReload
											size={18}
											color="#206c77"
											style={{
												cursor: 'pointer',
												marginRight: '10px',
												verticalAlign: 'middle',
											}}
											onClick={() => {
												setDataVoucherSelect([]);
												setDataVoucherDetail('');
												setParams({
													...params,
													page: 1,
													limit: 20,
													q: '',
												});
											}}
										/>
									</div>
									<span>{title}</span>
								</div>
							</div>
							<div className="column-start box_voucher__body">
								<div className="box_voucher__body__content">
									<TableManager
										idTable={'tableVoucherHD3'}
										columns={columns}
										data={dataVoucherHD3 || []}
										updateMyData={updateMyData}
										skipReset={skipResetRef.current}
										settingRow={true}
										selectRow={true}
										onSelectRowClick={onSelectRowClick}
										readonly={true}
										onRowClick={onRowClick}
										onRowDoubleClick={onRowDoubleClick}
										TbodyMaxHeight={'37vh'}
										TbodyMinHeight={'37vh'}
										pagination={true}
										isPage={params.page}
										isLimit={params.limit}
										totalRows={totalRows}
										handlePaginationChange={handlePaginationChange}
										toolBar={
											<div className="flex-start">
												<div>
													<VButton.Filter title="Tìm">
														<VoucherFilter
															onFilter={handleFilter}
															title={'Filter Voucher'}
														/>
													</VButton.Filter>
												</div>
												<div className="flex-start box_voucher__body__header">
													{MenuTabTable.map((item) => {
														const shouldDisplayItem =
															(dataVoucherSelect.length === 1 ||
																(item.id !== 2 && item.id !== 4)) &&
															(dataVoucherSelect.length > 0 || item.id !== 3);

														if (shouldDisplayItem) {
															return (
																<button
																	key={item.id}
																	onClick={item.handle}
																	title={`${item.name}`}
																>
																	{item.icon}{' '}
																	<span className="tabname_tool_bar">
																		{item.name}
																	</span>
																</button>
															);
														}

														return null;
													})}
												</div>
											</div>
										}
									/>
								</div>
							</div>
						</div>
						<div className="box_voucher_detail column-start">
							<DetailVoucherHD3
								data={dataVoucherDetail}
								readonly={true}
								view={true}
								selectRow={false}
								isFieldNt={{
									ma_nt: dataVoucherDetail?.ma_nt,
									ty_gia: dataVoucherDetail?.ty_gia,
								}}
							/>
						</div>
						<div className="total_price_voucher">
							<div>
								<span>Tổng số tiền: </span>
								<span>{handleSumTotal(dataVoucherHD3)}</span>
							</div>
						</div>
						{dataDoubleClick && (
							<EditVoucherHD3
								api={api}
								title={title}
								open={true}
								handleClose={handleCloseEdit}
								data={dataDoubleClick}
								getDataVoucherHD3={getDataVoucherHD3}
							/>
						)}
						{dataVoucherSelect && dataVoucherSelect.length > 0 ? (
							<>
								<EditVoucherHD3
									api={api}
									title={title}
									open={openEdit}
									handleClose={handleCloseEdit}
									data={dataVoucherSelect}
									getDataVoucherHD3={getDataVoucherHD3}
								/>
								<CopyVoucherHD3
									api={api}
									title={title}
									open={openCopy}
									handleClose={handleCloseCopy}
									data={handleDataCopyVoucher(dataVoucherSelect)}
									getDataVoucherHD3={getDataVoucherHD3}
								/>
							</>
						) : (
							<>
								<NotiDialog
									open={openEdit}
									handleClose={handleCloseEdit}
									title="Thông báo"
									content="Vui lòng chọn 1 dòng để thực hiện chức năng này"
								/>
								<NotiDialog
									open={openDelete}
									handleClose={handleCloseDelete}
									title="Thông báo"
									content="Vui lòng chọn ít nhất 1 dòng để thực hiện chức năng này"
								/>
								<NotiDialog
									open={openCopy}
									handleClose={handleCloseCopy}
									title="Thông báo"
									content="Vui lòng chọn ít nhất 1 dòng để thực hiện chức năng này"
								/>
							</>
						)}
						<AddVoucherHD3
							api={api}
							title={title}
							open={openAdd}
							handleClose={handleCloseAdd}
							getDataVoucherHD3={getDataVoucherHD3}
						/>
					</div>
				</LayoutContainer>
			</VoucherContext.Provider>
		</React.Fragment>
	);
}

export default withContainer(VoucherHD3);
